import styled from 'styled-components'
import {
	TituloH1 as TituloPrincipal,
	Descricao
} from '../../../../components/TituloSorriso/styles'
import { media } from '../../../../layouts/utils'

export const Wrapper = styled.div`
	${media.phone`
    height: 440px;
  `}
	position: relative;
	width: 100%;
	background: linear-gradient(180deg, #FF2832 0.01%, #333B8E 247.27%);
	height: 300px;
`;

export const Container = styled.div`
	display: flex;
	height: 100%;
	margin-left: auto;
	margin-right: auto;
	justify-content: space-between;
  align-items: center;
	width: 100%;
	${media.phone`
		height: 110%;
		flex-direction: column;
    justify-content: center;
  `}
`;

export const TextWrap = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	width: 50%;
	${media.phone`
		align-items: center;
		justify-content: center;
		padding-right: 0;
	`}
`;

export const Title = styled(TituloPrincipal)`
	padding: 0;
	padding-bottom: 10px;
	text-align: left;
	line-height: 45px;
	font-weight: 500;
	color: ${(props) => props.color};
	font-size: 36px;
	width: 85%;
	${media.phone`
		position: absolute;
		padding: 40px 32px;
		top: 0;
		text-align: center;
		line-height: 36px;
		width: 100%;
	`}
	${media.desktop`
		line-height: 28px;
		font-size: 28px;
	`}
	
`;

export const Text = styled(Descricao)`
	${media.phone`
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
  `}
	padding: 0;
	text-align: left;
	max-width: 550px;
`;

export const Image = styled.img`
	max-width: 500px;
	height: auto;

	${media.phone`
		width: 90%;
		position: absolute;
  `}
	${media.desktop`
		max-width: 445px;
  `}
`;
export const ContainerImagem = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 50%;
	margin-top: 10px;
	@media (min-width: 768px) and (max-width: 991px){
		margin: 0 40px 0px 30px; 
	}
`;
